import { orderSummaryCardStyles } from "@insite/content-library/Components/OrderSummaryCard";
import { css } from "styled-components";

orderSummaryCardStyles.orderNumberGridItem = { width: [12, 6, 6, 6, 6] };

orderSummaryCardStyles.orderNumberHeadingAndText = {
    heading: {
        css: css`
            padding-right: 10px;
        `,
    },
};
orderSummaryCardStyles.statusGridItem = { width: [12, 6, 6, 6, 6] };
orderSummaryCardStyles.statusHeadingAndText = {
    heading: {
        css: css`
            padding-right: 10px;
        `,
    },
};

orderSummaryCardStyles.webOrderNumberGridItem = { width: [12, 6, 6, 6, 6] };
orderSummaryCardStyles.webOrderNumberHeadingAndText = {
    heading: {
        css: css`
            padding-right: 10px;
        `,
    },
};
orderSummaryCardStyles.totalGridItem = { width: [12, 6, 6, 6, 6] };
orderSummaryCardStyles.totalHeadingAndText = {
    heading: {
        css: css`
            padding-right: 10px;
        `,
    },
};
